import { render, staticRenderFns } from "./My_Reports.vue?vue&type=template&id=f8c08036"
import script from "./My_Reports.vue?vue&type=script&lang=js"
export * from "./My_Reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports